import React from 'react';
import styled from 'styled-components';
import getImagePath from '../../../../../../../CommonUtils/getImagePath';
import { Wrapper, WrapperProps } from '../../../../../../../CommonComponents/OPL/Wrapper/Wrapper';

const TOP = {
  routing: -99,
  account: -199,
};

const AchCheckImgContainer = styled(Wrapper)({
  height: 100,
  width: 217,
  overflow: 'hidden',
  position: 'relative',
});

interface AchCheckImgProps extends WrapperProps {
  focusedNumber?: 'routing' | 'account';
}

export const AchCheckImg: React.FC<AchCheckImgProps> = ({ focusedNumber, ...rest }) => {
  return (
    <AchCheckImgContainer {...rest}>
      <img
        width={215}
        src={getImagePath('payment/ach-check.png')}
        alt="Check"
        css={`
          position: absolute;
          top: ${focusedNumber ? TOP[focusedNumber] : 1}px;
        `}
      />
    </AchCheckImgContainer>
  );
};
